// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hot-sticky-header th[data-v-16402b3a]{top:120px;position:-webkit-sticky;position:sticky;background:rgba(12,12,12,.7);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px)}.front-stack-layer[data-v-16402b3a]{z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
